import React from "react"

import { SmallH3Title } from "../../../styles/Commons/Titles"
import FurnacesIcon from "../../../Icons/FurnacesIcon"

const Furnaces = () => {
  return (
    <div>
      <div className="icon-image">
        <FurnacesIcon />
      </div>
      <div className="icon-title">
        <SmallH3Title>Furnaces</SmallH3Title>
      </div>
    </div>
  )
}

export default Furnaces
